import PropTypes from "prop-types";
import React, { Component } from "react";
import { Divider, Message } from "semantic-ui-react";
import { DeclineRequest } from "./DeclineRequest";

export default class DocumentRequestActions extends Component {
  handleDeclineRequest = (data) => {
    const { declineRequest, docReq } = this.props;
    declineRequest(docReq.pid, data);
  };

  handleRemoveDocument = async () => {
    const { docReq, removeDocument } = this.props;
    removeDocument(docReq.pid, docReq.document_pid);
  };

  handleRemoveProvider = async () => {
    const { docReq, removeProvider } = this.props;
    removeProvider(docReq.pid, docReq.physical_item_provider.pid);
  };

  render() {
    const { docReq } = this.props;
    const isPending = docReq.state === "PENDING";
    return (
      <div className="bo-action-menu">
        <Divider horizontal>ACTION</Divider>

        {!isPending && (
          <Message size="small">
            <Message.Header>Request completed</Message.Header>
            <p>The request has been completed.</p>
          </Message>
        )}

        <Divider hidden />
        <DeclineRequest
          pid={docReq.pid}
          disabled={!isPending}
          onDecline={this.handleDeclineRequest}
        />
      </div>
    );
  }
}

DocumentRequestActions.propTypes = {
  docReq: PropTypes.object.isRequired,
  declineRequest: PropTypes.func.isRequired,
  removeProvider: PropTypes.func.isRequired,
  removeDocument: PropTypes.func.isRequired,
};

DocumentRequestActions.defaultProps = {};
